import useLogger from "./useLogger";

const useTrackManageAutoPay = () => {
  const logger = useLogger();
  return (userObj) => {
    logger.trackEvent(userObj?.name, { ...userObj });
  };
};

export default useTrackManageAutoPay;
